import { render, staticRenderFns } from "./ProductGrid.vue?vue&type=template&id=8bbd85b2&scoped=true&"
import script from "./ProductGrid.vue?vue&type=script&lang=ts&"
export * from "./ProductGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGrid.vue?vue&type=style&index=0&id=8bbd85b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbd85b2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsAdSlot: require('/var/www/packages/theme/components/atoms/AdSlot.vue').default,MoleculesPLPCareplanBanner: require('/var/www/packages/theme/components/molecules/PLPCareplanBanner.vue').default,MoleculesProductCard: require('/var/www/packages/theme/components/molecules/ProductCard.vue').default,MoleculesBannerCard: require('/var/www/packages/theme/components/molecules/BannerCard.vue').default})
